import { reducer, on } from 'ts-action';
import * as annotationTaskActions from '../actions/annotation-task.actions';
import { AnnotationState } from '../types/annotation-tasks.type';

declare module 'react-redux' {
  interface DefaultRootState {
    annotationState: AnnotationState;
  }
}

const getInitialState = (): AnnotationState => ({
  annotation: null,
  previousAnnotationTask: null,
});

export default reducer(
  getInitialState(),
  on(annotationTaskActions.setAnnotation, (state, { annotation }) => {
    return {
      ...state,
      annotation,
    };
  }),
  on(
    annotationTaskActions.setPreviousAnnotationTask,
    (state, { previousAnnotationTask }) => {
      return {
        ...state,
        previousAnnotationTask,
      };
    },
  ),
);
